import React from 'react';
import SectionHeading from '../atoms/SectionHeading';
import FeatureItem from '../molecules/FeatureItem';
import { ShieldCheck, Gem, Clock, Palette } from 'lucide-react';
import { motion } from 'framer-motion';

const DifferenceSection = () => {
    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.15
            }
        }
    };

    const itemVariants = {
        hidden: { opacity: 0, y: 20 },
        visible: {
            opacity: 1,
            y: 0,
            transition: {
                duration: 0.6,
                ease: "easeOut"
            }
        }
    };

    return (
        <section id="difference" className="py-24 bg-white">
            <div className="container mx-auto px-6">
                <SectionHeading
                    title="Why Thousands Trust Us"
                    subtitle="The Standard"
                />

                <motion.div
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, margin: "-50px" }}
                    variants={containerVariants}
                    className="grid grid-cols-2 md:grid-cols-4 gap-8 lg:gap-12 text-center"
                >
                    <motion.div variants={itemVariants}>
                        <FeatureItem
                            icon={ShieldCheck}
                            title="Hospital Hygiene"
                            description="Medical-grade sterilization for every single tool. Your health is priority #1."
                        />
                    </motion.div>
                    <motion.div variants={itemVariants}>
                        <FeatureItem
                            icon={Gem}
                            title="Premium Products"
                            description="Only authentic Gel-X and Japanese potted gels. No MMA acrylics ever."
                        />
                    </motion.div>
                    <motion.div variants={itemVariants}>
                        <FeatureItem
                            icon={Clock}
                            title="4+ Week Wear"
                            description="Our signature retention prep ensures zero lifting for over a month."
                        />
                    </motion.div>
                    <motion.div variants={itemVariants}>
                        <FeatureItem
                            icon={Palette}
                            title="Custom Artistry"
                            description="From hand-painted anime to 3D chrome, we bring your vision to life."
                        />
                    </motion.div>
                </motion.div>
            </div>
        </section>
    );
};

export default DifferenceSection;
